/**
 * @file Read-only payment card — the transaction and bank views of one payment.
 * Changing the counterparty is refused while the payment carries `amountDetails`.
 */
import * as React from 'react';
import Component from '../../AbstractComponent';
import { PaymentInterface } from '../../../Entity/Entities/Payment/PaymentInterface';
import { getPaymentBaseAccountDisplay } from '../../../Entity/Entities/Payment/BaseBankAccount';
import Time from '../../../Time/Time';
import Payment2State from '../../Partials/Payment/Payment2State';
import Button from '@material-ui/core/Button';
// import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import Constants from '../../../Action/Constants';
import { PromptDialog } from '../../Partials/Dialog/PromptDialog';
// import Searchbar from "../Searchbar/Searchbar";
// import Link from '@material-ui/core/Link';
import { PageTransition } from '../../Partials/Spinner/PageTransition';
import { DatePickerComponent } from '../DatePicker/DatePickerComponent';
import { CoachUpdateCounterparty } from '../Dialog/CoachUpdateCounterparty';

export default class Payment2DetailsReadonly extends Component {
  public state = {
    isChangeStatementPeriodPopupOpen: false,
    isSaving: false,
    newStatementPeriod: this.props.payment?.firstDateOfStatementPeriod,
    openCoachUpdateCounterparty: false,
    payment: null,
  };

  constructor(public props) {
    super(props);
  }
  public unlinkCounterparty = () => {
    this.setState({
      isSaving: true,
    });
    const payload: any = {
      paymentId: this.props.payment.id,
      payment: {
        companyId: null,
        contactId: null,
      },
    };

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_START,
        payload: {
          ...payload,
        },
        onSuccess: () => {
          this.setState(
            {
              errorFields: [],
              isSaving: false,
            },
            this.props.initializePage
          );
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields,
            errorMessage: err.message,
          });
        },
      });
    });
  };

  public changeCounterparty = (event, payment: PaymentInterface) => {
    if (Object.keys(payment?.amountDetails).length > 0) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans('readonly_payment_update_forbidden'),
          type: 'error',
        },
      });
    } else {
      if (!payment?.personId && !payment?.companyId) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
          openCoachUpdateCounterparty: true,
        });
      } else {
        event.preventDefault();
        event.stopPropagation();
        this.unlinkCounterparty();
      }
    }
  };

  public renderTransaction = (payment: PaymentInterface) => {
    const baseAccount = getPaymentBaseAccountDisplay({
      payment,
      agencyBankAccounts: this.getAgencyBankAccounts(),
      companies: this.props.app?.companies,
      agencyId: this.getAgency()?.id,
    });
    const hasParsedTransactionDescription =
      payment?.parsedTransactionDescription &&
      Object.keys(payment?.parsedTransactionDescription || {}).length > 0;
    const parsedTransactionDescriptionArray = [];

    if (hasParsedTransactionDescription) {
      for (let description in payment?.parsedTransactionDescription) {
        parsedTransactionDescriptionArray.push(
          `${description}: ${payment?.parsedTransactionDescription[description]}`
        );
      }
    }

    return (
      <div>
        <table>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/amount')}
            </td>
            <td className="align-left">
              <div style={{ display: 'flex' }}>
                {this.formatter.formatNumber(
                  payment?.amount,
                  payment?.currency
                )}
              </div>
            </td>
          </tr>
          {this.props.newCardStyles && (
            <tr>
              <td className="align-left first-column">
                {this.trans('payment-summary-state/status')}
              </td>
              <td className="align-left">
                <div style={{ display: 'flex' }}>
                  {this.renderStatus(payment)}
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/paidfrom')}
            </td>
            <td className="align-left">
              {payment?.isReceived && (
                <div>
                  {payment?.mainBankAccountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {payment?.name
                      ? payment?.name
                      : this.trans('payment-summary-details/unknown')}
                  </span>

                  <Button
                    color="primary"
                    style={{
                      padding: '4px 10px',
                      marginLeft: '12px',
                      lineHeight: 'normal',
                      whiteSpace: 'nowrap',
                      border: '1px solid',
                    }}
                    onClick={(event) => {
                      this.changeCounterparty(event, payment);
                    }}
                  >
                    {payment?.counterparty
                      ? this.trans('unlink-counterparty')
                      : this.trans('link-counterparty')}
                  </Button>
                </div>
              )}
              {payment?.isPaid && (
                <div>
                  {baseAccount.accountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {baseAccount.name}
                  </span>
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/paidto')}
            </td>
            <td className="align-left">
              {payment?.isPaid && (
                <div>
                  {payment?.mainBankAccountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {payment?.name
                      ? payment?.name
                      : this.trans('payment-summary-details/unknown')}
                  </span>
                  <Button
                    color="primary"
                    style={{
                      padding: '4px 10px',
                      marginLeft: '12px',
                      lineHeight: 'normal',
                      whiteSpace: 'nowrap',
                      border: '1px solid',
                    }}
                    onClick={(event) => {
                      this.changeCounterparty(event, payment);
                    }}
                  >
                    {payment?.personId || payment?.companyId
                      ? this.trans('unlink-counterparty')
                      : this.trans('link-counterparty')}
                  </Button>
                </div>
              )}
              {payment?.isReceived && (
                <div>
                  {baseAccount.accountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {baseAccount.name}
                  </span>
                </div>
              )}
            </td>
          </tr>
          {payment?.chargeIds?.length > 0 && (
            <tr>
              <td className="align-left first-column">
                {this.trans('charge-summary-details/ownerstatement')}
              </td>
              <td className="align-left">
                {`${Time.useFormat(
                  payment?.firstDateOfStatementPeriod,
                  'MMMM YYYY'
                )}`}
                {payment?.isReadonly && !payment?.isClosedInStatement && this.props.mainCardPresentation && (
                  <Button
                    color="primary"
                    style={{
                      padding: '4px 10px',
                      marginLeft: '12px',
                      lineHeight: 'normal',
                      whiteSpace: 'nowrap',
                      border: '1px solid',
                    }}
                    onClick={() => {
                      this.setState({
                        isChangeStatementPeriodPopupOpen: true,
                      });
                    }}
                  >
                    {this.trans(
                      'page/paymentupdate-link/updatestatementperiod'
                    )}
                  </Button>
                )}
              </td>
            </tr>
          )}
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/description')}
            </td>
            <td className="align-left">{payment?.description}</td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/transactiondetails')}
            </td>
            <td className="align-left">
              {parsedTransactionDescriptionArray.map((description) => (
                <div>{description}</div>
              ))}
            </td>
          </tr>
        </table>
      </div>
    );
  };

  public renderBank = (payment: PaymentInterface) => {
    const baseAccount = getPaymentBaseAccountDisplay({
      payment,
      agencyBankAccounts: this.getAgencyBankAccounts(),
      companies: this.props.app?.companies,
      agencyId: this.getAgency()?.id,
    });

    return (
      <div>
        <table>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/amount')}
            </td>
            <td className="align-left">
              <div style={{ display: 'flex' }}>
                {this.formatter.formatNumber(
                  payment?.amount,
                  payment?.currency
                )}
              </div>
            </td>
          </tr>
          {this.props.newCardStyles && (
            <tr>
              <td className="align-left first-column">
                {this.trans('payment-summary-state/status')}
              </td>
              <td className="align-left">
                <div style={{ display: 'flex' }}>
                  {this.renderStatus(payment)}
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/paidfrom')}
            </td>
            <td className="align-left">
              {payment?.isReceived && (
                <div>
                  {payment?.mainBankAccountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {payment?.name}
                  </span>
                </div>
              )}
              {payment?.isPaid && (
                <div>
                  {baseAccount.accountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {baseAccount.name}
                  </span>
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/paidto')}
            </td>
            <td className="align-left">
              {payment?.isPaid && (
                <div>
                  {payment?.mainBankAccountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {payment?.name}
                  </span>
                </div>
              )}
              {payment?.isReceived && (
                <div>
                  {baseAccount.accountId}
                  <span style={{ marginLeft: '5px', color: '#ababab' }}>
                    {baseAccount.name}
                  </span>
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('charge-summary-details/ownerstatement')}
            </td>
            <td className="align-left">
              {`${Time.useFormat(
                payment?.firstDateOfStatementPeriod,
                'MMMM YYYY'
              )}`}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/description')}
            </td>
            <td className="align-left">{payment?.description}</td>
          </tr>
        </table>
      </div>
    );
  };

  public renderCash = (payment: PaymentInterface) => {
    return (
      <div>
        <table>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/amount')}
            </td>
            <td className="align-left">
              <div style={{ display: 'flex' }}>
                {this.formatter.formatNumber(
                  payment?.amount,
                  payment?.currency
                )}
              </div>
            </td>
          </tr>
          {this.props.newCardStyles && (
            <tr>
              <td className="align-left first-column">
                {this.trans('payment-summary-state/status')}
              </td>
              <td className="align-left">
                <div style={{ display: 'flex' }}>
                  {this.renderStatus(payment)}
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/type')}
            </td>
            <td className="align-left">
              {this.trans(`payment_type_${payment?.paymentType?.label}`)}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('charge-summary-details/ownerstatement')}
            </td>
            <td className="align-left">
              {`${Time.useFormat(
                payment?.firstDateOfStatementPeriod,
                'MMMM YYYY'
              )}`}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/description')}
            </td>
            <td className="align-left">{payment?.description}</td>
          </tr>
        </table>
      </div>
    );
  };

  public renderOther = (payment: PaymentInterface) => {
    return (
      <div>
        <table>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/amount')}
            </td>
            <td className="align-left">
              <div style={{ display: 'flex' }}>
                {this.formatter.formatNumber(
                  payment?.amount,
                  payment?.currency
                )}
              </div>
            </td>
          </tr>
          {this.props.newCardStyles && (
            <tr>
              <td className="align-left first-column">
                {this.trans('payment-summary-state/status')}
              </td>
              <td className="align-left">
                <div style={{ display: 'flex' }}>
                  {this.renderStatus(payment)}
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/type')}
            </td>
            <td className="align-left">
              {this.trans(`payment_type_${payment?.paymentType?.label}`)}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('charge-summary-details/ownerstatement')}
            </td>
            <td className="align-left">
              {`${Time.useFormat(
                payment?.firstDateOfStatementPeriod,
                'MMMM YYYY'
              )}`}
            </td>
          </tr>
          <tr>
            <td className="align-left first-column">
              {this.trans('payment-summary-details/description')}
            </td>
            <td className="align-left">{payment?.description}</td>
          </tr>
        </table>
      </div>
    );
  };

  public renderContent = (payment: PaymentInterface) => {
    if (payment?.hasTransaction) {
      return this.renderTransaction(payment);
    }

    if (payment?.hasBankType) {
      return this.renderBank(payment);
    }

    if (payment?.hasCashType) {
      return this.renderCash(payment);
    }

    if (payment?.hasOtherType || payment?.hasSavingsType) {
      return this.renderOther(payment);
    }

    if (payment?.hasSettlementType) {
      return this.renderOther(payment);
    }
  };

  public updateParentState = (callback?) => {
    if (typeof this.props.updateState === 'function') {
      this.props.updateState.call(this, { ...this.state }, callback);
    }
  };

  public selectDate = (date: Date, identifier: string): void => {
    this.setState({
      [identifier]: date,
      hasModifiedData: true,
    });
  };

  public renderStatementPeriodDialogContent = () => {
    return (
      <div>
        <p>
          {this.trans('page/paymentupdate-dialog/updatestatementperiod-hint')}
        </p>
        <DatePickerComponent
          {...this.props}
          id="firstDateOfStatementPeriodForPayment"
          name="firstDateOfStatementPeriodForPayment"
          className="scroll-to-firstDateOfStatementPeriodForPayment"
          label={this.trans('section/payment-field/forperiod-label')}
          initialDate={this.state.newStatementPeriod}
          onChange={(date) => this.selectDate(date, 'newStatementPeriod')}
          clearButton={false}
          openTo={'month'}
          views={['year', 'month']}
          disableKeyboard={true}
          error={this.getErrorFor('firstDateOfStatementPeriodForPayment')}
        />
      </div>
    );
  };

  public updateStatementPeriod = (payment: PaymentInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_START,
        payload: {
          paymentId: payment?.id,
          payment: {
            firstDateOfStatementPeriod: Time.formatOrNull(
              this.state.newStatementPeriod
            ),
          },
        },
        onSuccess: (payment: PaymentInterface) => {
          this.props.updateState.call(this, payment)
          this.setState({
            isSaving: false,
            isChangeStatementPeriodPopupOpen: false,
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
          });
        },
      });
    });
  };

  public getReadonlyReason = (payment: PaymentInterface) => {
    if (payment?.removed) {
      return this.trans('section/payment-info/isremoved');
    } else if (payment?.creationType?.id === 2) {
      return this.trans('payment-summary-readonly/transaction');
    } else if (payment?.creationType?.id === 7) {
      return this.trans('payment-summary-readonly/ponto');
    } else if (payment?.isSettle && !payment?.hasSavingsType) {
      return this.trans(
        'page/paymentupdate-section/payment-info/cantupdatesettlepayment'
      );
    } else if (payment?.hasSavingsType || payment?.isReferencedToSavings) {
      return this.trans(
        'page/paymentupdate-section/payment-info/specialcreatedsavingspayment'
      );
    } else if (payment?.hasSettlementType) {
      return this.trans(
        'page/paymentupdate-section/payment-info/specialcreatedsettlepayment'
      );
    } else if (payment?.isRefunded) {
      return this.trans('payment-summary-readonly/refund');
    }
  };

  public renderRemovedState = () => {
    return this.trans('payment-summary-state/removed').toLowerCase();
  };

  public renderUnusedState = () => {
    return this.trans('payment-summary-state/unused').toLowerCase();
  };

  public renderUsedState = () => {
    return this.trans('payment-summary-state/used').toLowerCase();
  };

  public renderPartialUsedState = (payment: PaymentInterface) => {
    return (
      <div>
        {this.trans('payment-summary-state/part-unused')}{' '}
        <span style={{ color: '#ababab' }}>
          {payment?.currency?.getIso()}{' '}
          {this.formatter.formatNumber(payment?.amountRemaining)}
        </span>
      </div>
    );
  };

  public renderStatus = (payment: PaymentInterface) => {
    if (payment?.removed) {
      return this.renderRemovedState();
    }

    if (payment?.isFullyUsed()) {
      return this.renderUsedState();
    }

    if (payment?.amountUsed === 0) {
      return this.renderUnusedState();
    }

    if (payment?.amountRemaining > 0) {
      return this.renderPartialUsedState(payment);
    }
  };

  public render() {
    const payment: PaymentInterface = this.props.payment;
    // const counterpartyName = payment?.name;

    return (
      <div className="payment-details-readonly">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div className="title">
            {payment?.isReceived
              ? this.trans('payment-summary-title/receivable')
              : this.trans('payment-summary-title/payable')}
          </div>
          <div className="date">
            {this.formatter.formatDate(payment?.dateOfThePayment)}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <div className="counterparty">
            {`${payment?.getPayerDisplayName()}	${
              payment?.hasSavingsType
                ? `(${this.trans('charge/payment-summary-title/savings')})`
                : ''
            }`}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex' }}>
              <div className="currency">{payment?.currency?.getIso()}</div>
              <div className="amount">
                {this.formatter.formatNumber(payment?.amount)}
                {/* {!this.props.newCardStyles ? this.formatter.formatNumber(payment?.amount) : this.formatter.formatNumber(payment?.amountUsedForCharges(payment?.chargeIds))} */}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {this.renderContent(payment)}
          <div
            style={{
              position: 'relative',
              top: '0px',
              minWidth: 'fit-content',
            }}
          >
            {/* {this.props.newCardStyles ?  */}
            {/* !payment?.isFullyUsed() && (
							<div style={{display: "flex", alignItems: "center"}}>
								<div style={{fontSize: "16px"}}>
									{this.trans("payment").toLowerCase()}
								</div>
								<div style={{marginLeft: "5px", fontSize: "16px"}}>
									{this.formatter.formatNumber(payment?.amount)}
								</div>
								<div style={{marginLeft: "5px", fontSize: "16px"}}>
									{payment?.currency?.getIso()}
								</div>
							</div>
						)
						: */}
            <Payment2State {...this.props} payment={payment} />
            {/* } */}
          </div>
        </div>
        {payment?.isReadonly && this.props.mainCardPresentation && (
          <div className="readonly-reason" style={{ flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span
                className="list-label readonly"
                style={{ marginRight: '5px' }}
              >
                {payment?.isReadonly && this.trans('label-readonly')}
              </span>
              <div>{this.getReadonlyReason(payment)}</div>
            </div>
          </div>
        )}
        {this.props.mainCardPresentation && !payment?.isReadonly && (
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: this.props.unActionButton
                ? 'space-between'
                : 'flex-start',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                if (typeof this.props.openEditableView === 'function') {
                  this.props.openEditableView();
                }
              }}
            >
              {this.trans('button-update')}
            </Button>
          </div>
        )}
        {!this.props.mainCardPresentation && (
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: this.props.unActionButton
                ? 'space-between'
                : 'flex-start',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                this.props.onPressOpenFromChargePage &&
                  this.props.onPressOpenFromChargePage.call(this);
                this.redirect(`/app/payment/update/${payment?.id}`);
              }}
            >
              {this.trans('button-open')}
            </Button>
            {this.props.unActionButton}
          </div>
        )}

        {this.state.openCoachUpdateCounterparty && (
          <CoachUpdateCounterparty
            {...this.props}
            payment={this.props.payment}
            openCoachUpdateCounterparty={this.state.openCoachUpdateCounterparty}
            // initializePage={this.props.initializePage}
            onCloseCoach={() => {
              this.setState({
                openCoachUpdateCounterparty: false,
              });
            }}
          />
        )}

        <PromptDialog
          {...this.props}
          title={this.trans(
            'page/paymentupdate-dialog/updatestatementperiod-title'
          )}
          content={this.renderStatementPeriodDialogContent()}
          positiveButtonLabel={this.trans('button-continue')}
          negativeButtonLabel={this.trans('button-cancel')}
          openLeavePrompt={this.state.isChangeStatementPeriodPopupOpen}
          prioritizeClosing={true}
          onDiscard={() =>
            this.setState({ isChangeStatementPeriodPopupOpen: false })
          }
          onSave={this.updateStatementPeriod.bind(this, payment)}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
